import './TaxonomyEditor.scss'
import React from "react";
import {observer} from "mobx-react-lite";
import {useStores} from "../../stores";
import {Alert, Button, Dialog, Grid, Typography} from "@mui/material";
import {Add} from "@mui/icons-material";
import {MoveCategoryModal} from "./modals/MoveCategoryModal";
import {CreateCategoryModal} from "./modals/CreateCategoryModal";
import {MergeCategoryModal} from "./modals/MergeCategoryModal";
import {TaxonomyEditor} from "../../components/visualization/taxonomy-editor/TaxonomyEditor";
import {UpdateCategoryModal} from "./modals/UpdateCategoryModal";
import {useNavigate} from "react-router";
import {LoadingSpinnerPie} from "../../components/loading-pie/LoadingSpinnerPie";
import {TaxonomyApprovalAlert} from "./alerts/TaxonomyApprovalAlert";

type Props = {
    viewer?: boolean
}
export const TaxonomyEditorComponent: React.FC<Props> = observer(({viewer}) => {
    const {bagStore, taxonomyEditorStore, taxonomyManagerStore, p, authStore} = useStores();
    const navigate = useNavigate();

    // TODO: Disable edit mode for the taxonomy editor when navigation happens
    //  >>> OK

    const viewMode = taxonomyEditorStore.isFullViewMode ? 'full' : 'fit';
    return <>
        <Dialog
            open={
                taxonomyEditorStore.isUpdateCategoryMode
                || taxonomyEditorStore.isCreateCategoryMode
                || taxonomyEditorStore.isMergeCategoryMode
                || taxonomyEditorStore.isMoveCategoryMode
            }
            maxWidth="lg"
        >
            {taxonomyEditorStore.isUpdateCategoryMode && <UpdateCategoryModal/>}
            {taxonomyEditorStore.isCreateCategoryMode && <CreateCategoryModal/>}
            {taxonomyEditorStore.isMergeCategoryMode && <MergeCategoryModal/>}
            {taxonomyEditorStore.isMoveCategoryMode && <MoveCategoryModal/>}
        </Dialog>

        <div className={`taxonomy-editor-body view-mode-${viewMode}`}>

            {!viewer &&
                <Grid container justifyContent="center" alignItems="center">
                    <Grid flexGrow={1} flexBasis={0} className="text-right">
                        {(taxonomyEditorStore.isEditMode && taxonomyEditorStore.focus?.parent) &&
                            <Typography component="span" style={{marginRight: '2em'}}>
                                Selected: {taxonomyEditorStore.focus?.data.label || 'None'}
                            </Typography>
                        }
                    </Grid>
                    <Grid className="">
                        {taxonomyEditorStore.isEditMode &&
                            <Button
                                disabled={!taxonomyManagerStore.canEditTaxonomy}
                                className="toolbar-btn large-icon-btn wider-button z-bg-button"
                                color="primary"
                                variant="outlined"
                                startIcon={<Add/>}
                                onClick={() => taxonomyEditorStore.setCreateCategoryMode(true)}>
                                Add L{'' + taxonomyEditorStore.focusLevel}
                            </Button>
                        }
                    </Grid>
                    <Grid flexGrow={1}/>
                </Grid>
            }
            <Grid container justifyContent="center">
                {taxonomyManagerStore.error &&
                    <Grid><Alert severity="error">{taxonomyManagerStore.error}</Alert></Grid>
                }
                <TaxonomyApprovalAlert gridItem/>

                {taxonomyManagerStore.taxonomy &&
                    <Grid size={12}>
                        <TaxonomyEditor/>
                    </Grid>
                }
                {(taxonomyManagerStore.taxonomy === undefined && !taxonomyManagerStore.error) &&
                    <Grid className="loading-mid-page"><LoadingSpinnerPie/></Grid>
                }

                {(taxonomyManagerStore.taxonomy === null && !taxonomyManagerStore.error) &&
                    <Grid className="loading-mid-page">No taxonomy selected for this dataset</Grid>
                }
            </Grid>
        </div>
    </>;
});
